const initialState = [];

export default (state=initialState, action) => {
	switch (action.type) {
		case 'SET_AUTH_USER_NUMBER':
			if(state.length === 0) {
				return [...state, ...(new Array(action.num).fill(null).map((val, i) => {
					return ({
						// PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
						// PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
						id: i, firstName: "", lastName: "", birthdate: "", address1: "", address2: "", city: "", province: "BC", postalCode: "", mobilePhone: "", homePhone: "", email: "", status: "Employed", industry: "", occupationName: "", noc: ""
					})
				}))];
			}
			else {
				if(state.length > action.num) {
					return [...state.slice(0, action.num)];
				}
				else {
					// Find the larest array index, and add one to make it unqiue
					let id = Math.max(...state.map(authUser => authUser.id), 0) + 1;
					// PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
					// PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
					return [...state, ...(new Array(action.num - state.length).fill(null).map((val, i) => ({id: i + id, firstName: "", lastName: "", birthdate: "", address1: "", address2: "", city: "", province: "BC", postalCode: "", mobilePhone: "", homePhone: "", email:  "", status: "Employed", industry: "", occupationName: "", noc: ""})))];
				}
			}
		case 'SAVE_AUTH_USER':					
			return [...state.slice(0, action.index), action.authUser, ...state.slice(action.index + 1, state.length)];
		case 'REMOVE_AUTH_USER':		
			return [...state.slice(0, action.index), ...state.slice(action.index + 1, state.length)];
		default: 
			return state			
	}
}


// WEBPACK FOOTER //
// ./src/reducers/authUserReducer.js